  import React from 'react';
  import { DeleteTwoTone } from '@ant-design/icons';
  import { message, Popconfirm } from 'antd';
  import { useDispatch } from 'react-redux';
  import { deleteCompany } from '../../../redux/Company/actions';

  export const DeleteCompany = ({ item, onRefresh }) => {
    const dispatch = useDispatch();

    const deleteCompanyFun = () => {
      dispatch(deleteCompany(item._id)).then(() => {
        message.success('Deleted');
        onRefresh();
      });
    };

    return (
      <Popconfirm
        onConfirm={deleteCompanyFun}
        title="Are you sure you want to delete this company?"
        okText="Yes"
        cancelText="No"
      >
        <DeleteTwoTone twoToneColor="red" />
      </Popconfirm>
    );
  };

  export default DeleteCompany;
